import styles from '@features/cms/components/collections/SpacingBlock/SpacingBlock.styles';
import { ISpacingBlock } from '@features/cms/typescript';
type PropsType = {
  data: ISpacingBlock;
};
const SpacingBlock = ({
  data
}: PropsType) => {
  const {
    backgroundColor,
    code,
    height
  } = data;
  return <div id={code} sx={styles.spacingBlock(backgroundColor, height)} data-testid="spacing-block" />;
};
export default SpacingBlock;